import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../user.model';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';

@Component({
  selector: 'app-user-item',
  imports: [AvatarComponent],
  templateUrl: './user-item.component.html',
  styleUrl: './user-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserItemComponent {
  readonly #router = inject(Router);

  readonly user = input.required<User>();

  protected navigateToDetails() {
    const { id, role } = this.user();
    if (!id) return;

    const section = role === 'admin' || role === 'operator' ? 'operators' : 'users';
    this.#router.navigate(['/main', section, id]);
  }
}
